import './Header.scss';
import useUrlParams from '../../hooks/useUrlParams';
import { AcpLogo, BackSvg } from '../../../CommonComponents/svgs/Svgs';
import RightContainer from './RightContainer';

const Header = () => {
    const { navigate_home, navigate_back } = useUrlParams();

    return (
        <div className='gs__header'>
            <div className='gs__header__left'>
                <button className='gs__header__logo' onClick={navigate_home}>
                    <AcpLogo />
                </button>
                <div className='gs__header__back__container'>
                    <button className='gs__header__back__btn' onClick={navigate_back}>
                        <BackSvg />
                    </button>
                </div>
            </div>
            <div className='gs__header__right'>
                <RightContainer />
            </div>
        </div>
    );
};

export default Header;
